var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaf = function SvgCaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 0h512v341.3H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170.7h211.5V256H0zm300.5 0H512V256H300.5z",
    fill: "#6DA544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 0v85.3h211.5V0h89v85.3H512V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.5 341.3h-89V256H0v85.3h512V256H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#FFDA44"
  })));
};
export { SvgCaf as ReactComponent };